import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { Header } from '@/common/components/features/header';
import { AbilityProvider } from '@/common/components/features/role-management';
import { useAuth } from '@/common/hooks/use-auth';

const redirectToLogin = (redirectUrl: string): never => {
  throw redirect({
    to: '/entrar',
    search: { redirect: redirectUrl },
  });
};

const AppLayout = () => {
  const { user } = useAuth();

  return (
    <AbilityProvider role={user?.role}>
      <div className='flex flex-col h-full w-full'>
        <Header />
        <Outlet />
      </div>
    </AbilityProvider>
  );
};

export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => {
    const { auth } = context;
    if (!auth.signedIn) {
      redirectToLogin(location.href);
    }
  },
  component: AppLayout,
});
